import { Stack } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import type { ContentReportStep } from "Components/Support/ContentReport/ContentReportStep";
import { CONTENT_REPORT_FORM_ID } from "Components/Support/supportFormIds";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Support.ContentReport;

type Props = {
  step: ContentReportStep;
  isSubmitInFlight: boolean;
  onCancel: () => void;
  onRetry: () => void;
};

/**
 * Whether a step has an action bar at all is the dialog's call (ResponsiveDialog opens the
 * footer slot for any element, even one that renders nothing), so this never returns null —
 * it only decides what the bar contains.
 */
export const ContentReportFooter = ({
  step,
  isSubmitInFlight,
  onCancel,
  onRetry,
}: Props) => {
  const { t } = useResource();

  if (step === "result") {
    return (
      <Stack direction="row" justifyContent="flex-end" gap={2}>
        <PrimaryButton
          size="small"
          color="info"
          variant="outlined"
          onClick={onRetry}
        >
          {t(Resources.Common.Retry)}
        </PrimaryButton>
      </Stack>
    );
  }

  return (
    <Stack direction="row" justifyContent="flex-end" gap={2}>
      <PrimaryButton
        size="small"
        color="info"
        variant="outlined"
        onClick={onCancel}
        disabled={isSubmitInFlight}
      >
        {t(RESOURCES.CancelButton)}
      </PrimaryButton>
      {/* The form element is in the step above this footer, so the button has to reach
          it by id rather than by being nested inside it. */}
      <PrimaryButton
        size="small"
        type="submit"
        form={CONTENT_REPORT_FORM_ID}
        color="primary"
        isLoading={isSubmitInFlight}
        disabled={isSubmitInFlight}
      >
        {t(RESOURCES.SubmitButton)}
      </PrimaryButton>
    </Stack>
  );
};
